function DesktopIcon({ color = "currentColor", className, style }) {
  return (
    <svg width={42} height={39} viewBox="0 0 42 39" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={{ color, ...style }}>
      <path d="M11.667 36.583h18.666m-28-32v21.334A2.667 2.667 0 005 28.583h32a2.667 2.667 0 002.667-2.666V4.583A2.667 2.667 0 0037 1.917H5a2.667 2.667 0 00-2.667 2.666z" stroke="currentColor" strokeWidth={3} />
    </svg>
  );
}
export default DesktopIcon;
